import { t } from 'i18next';
import { observer } from 'mobx-react-lite';

import OrderBySelector, {
  AvailableOrderOption,
  OrderOption,
} from '~components/OrderBySelector/OrderBySelector';
import { useStores } from '~store/RootStore';

import { DriverDayQueryOrdersSort } from '../../constants';

const ordersSortOptions: AvailableOrderOption<DriverDayQueryOrdersSort>[] = [
  {
    value: DriverDayQueryOrdersSort.DRIVER_DAY_DATE,
    label: t('approvals.driver_day.sort.driver_day_date'),
  },
  {
    value: DriverDayQueryOrdersSort.DRIVER_NAME,
    label: t('approvals.driver_day.sort.driver_name'),
  },
  // Disabled until we resolve this backend issue: https://linear.app/treadapp/issue/TRE-11790/prev-link-for-sort-params-that-have-nullable-columns-is-incorrect
  // {
  //   value: DriverDayQueryOrdersSort.VENDOR_ACCOUNT_NAME,
  //   label: t('approvals.driver_day.sort.vendor_account_name'),
  // },
];

const OrderSelectorCTA = observer(() => {
  const { driverDayStore } = useStores();

  const handleSortChange = (sort: OrderOption<DriverDayQueryOrdersSort>) => {
    driverDayStore.setDriverDaySort(sort);
  };

  return (
    <OrderBySelector
      onChange={handleSortChange}
      order={driverDayStore.driverDaySort}
      orderOptions={ordersSortOptions}
    />
  );
});

export default OrderSelectorCTA;
